// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ReactionItem__container-f8a51b {
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  padding-top: var(--container-padding-top);
  padding-bottom: var(--container-padding-bottom);
  padding-inline-start: var(--container-padding-inline-start);
  padding-inline-end: var(--container-padding-inline-end);
  background: var(--background-color);
  border-radius: var(--border-radius);
}

.ReactionItem__container-f8a51b:hover,
.ReactionItem__container-f8a51b:focus-visible {
  transition: transform 150ms;
  transform-origin: center bottom;
  transform: var(--container-transform-focus);
}

.ReactionItem__icon-b8b6bb {
  display: flex;
  justify-content: center;
  align-items: center;
  width: var(--icon-width);
  height: var(--icon-height);
}

.ReactionItem__counter-e65396 {
  margin-inline-start: 4px;
  color: var(--counter-font-color);
  font: var(--font-subtitle-3);
  letter-spacing: var(--font-spacing-subtitle-3);
}

.ReactionItem__selected-bc5ec9.ReactionItem__container-f8a51b {
  background: var(--background-color-selected);
}

.ReactionItem__selected-bc5ec9 .ReactionItem__counter-e65396 {
  color: var(--counter-font-color-selected);
  font: var(--font-subtitle-2);
  letter-spacing: var(--font-spacing-subtitle-2);
}

.ReactionItem__theme-1-a46685,
.ReactionItem__theme-2-ba5e7a {
  --container-padding-top: 4px;
  --container-padding-bottom: 4px;
  --container-padding-inline-start: 6px;
  --container-padding-inline-end: 8px;
  --container-transform-focus: none;
  --background-color: var(--average-background);
  --background-color-selected: var(--addition-50);
  --border-radius: 100px;
  --icon-width: 20px;
  --icon-height: 20px;
  --counter-font-color: var(--addition-50);
  --counter-font-color-selected: var(--addition-110);
}

.ReactionItem__theme-3-a55fc3,
.ReactionItem__theme-4-d8d183 {
  --container-padding-top: 4px;
  --container-padding-bottom: 4px;
  --container-padding-inline-start: 6px;
  --container-padding-inline-end: 8px;
  --container-transform-focus: none;
  --background-color: var(--addition-110_50);
  --background-color-selected: var(--addition-50);
  --border-radius: 100px;
  --icon-width: 20px;
  --icon-height: 20px;
  --counter-font-color: var(--addition-50);
  --counter-font-color-selected: var(--addition-40);
}

.ReactionItem__theme-6-af19a8 {
  --container-padding-top: 2px;
  --container-padding-bottom: 2px;
  --container-padding-inline-start: 2px;
  --container-padding-inline-end: 2px;
  --container-transform-focus: scale(1.2);
  --background-color: transparent;
  --background-color-selected: var(--base-30);
  --border-radius: 32px;
  --icon-width: 28px;
  --icon-height: 28px;
  --counter-font-color: transparent;
  --counter-font-color-selected: transparent;
}`, "",{"version":3,"sources":["webpack://./src/components/Reactions/ReactionItem/ReactionItem.styles.m.css"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,yCAAA;EACA,+CAAA;EACA,2DAAA;EACA,uDAAA;EACA,mCAAA;EACA,mCAAA;AACF;;AAEA;;EAEE,2BAAA;EACA,+BAAA;EACA,2CAAA;AACF;;AAEA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,wBAAA;EACA,0BAAA;AACF;;AAEA;EACE,wBAAA;EACA,gCAAA;EACA,4BAAA;EACA,8CAAA;AACF;;AAEA;EACE,4CAAA;AACF;;AAEA;EACE,yCAAA;EACA,4BAAA;EACA,8CAAA;AACF;;AAEA;;EAEE,4BAAA;EACA,+BAAA;EACA,qCAAA;EACA,mCAAA;EACA,iCAAA;EACA,6CAAA;EACA,+CAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,wCAAA;EACA,kDAAA;AACF;;AAEA;;EAEE,4BAAA;EACA,+BAAA;EACA,qCAAA;EACA,mCAAA;EACA,iCAAA;EACA,0CAAA;EACA,+CAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,wCAAA;EACA,iDAAA;AACF;;AAEA;EACE,4BAAA;EACA,+BAAA;EACA,qCAAA;EACA,mCAAA;EACA,uCAAA;EACA,+BAAA;EACA,2CAAA;EACA,qBAAA;EACA,kBAAA;EACA,mBAAA;EACA,iCAAA;EACA,0CAAA;AACF","sourcesContent":[".container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  padding-top: var(--container-padding-top);\n  padding-bottom: var(--container-padding-bottom);\n  padding-inline-start: var(--container-padding-inline-start);\n  padding-inline-end: var(--container-padding-inline-end);\n  background: var(--background-color);\n  border-radius: var(--border-radius);\n}\n\n.container:hover,\n.container:focus-visible {\n  transition: transform 150ms;\n  transform-origin: center bottom;\n  transform: var(--container-transform-focus);\n}\n\n.icon {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: var(--icon-width);\n  height: var(--icon-height);\n}\n\n.counter {\n  margin-inline-start: 4px;\n  color: var(--counter-font-color);\n  font: var(--font-subtitle-3);\n  letter-spacing: var(--font-spacing-subtitle-3);\n}\n\n.selected.container {\n  background: var(--background-color-selected);\n}\n\n.selected .counter {\n  color: var(--counter-font-color-selected);\n  font: var(--font-subtitle-2);\n  letter-spacing: var(--font-spacing-subtitle-2);\n}\n\n.theme-1,\n.theme-2 {\n  --container-padding-top: 4px;\n  --container-padding-bottom: 4px;\n  --container-padding-inline-start: 6px;\n  --container-padding-inline-end: 8px;\n  --container-transform-focus: none;\n  --background-color: var(--average-background);\n  --background-color-selected: var(--addition-50);\n  --border-radius: 100px;\n  --icon-width: 20px;\n  --icon-height: 20px;\n  --counter-font-color: var(--addition-50);\n  --counter-font-color-selected: var(--addition-110);\n}\n\n.theme-3,\n.theme-4 {\n  --container-padding-top: 4px;\n  --container-padding-bottom: 4px;\n  --container-padding-inline-start: 6px;\n  --container-padding-inline-end: 8px;\n  --container-transform-focus: none;\n  --background-color: var(--addition-110_50);\n  --background-color-selected: var(--addition-50);\n  --border-radius: 100px;\n  --icon-width: 20px;\n  --icon-height: 20px;\n  --counter-font-color: var(--addition-50);\n  --counter-font-color-selected: var(--addition-40);\n}\n\n.theme-6 {\n  --container-padding-top: 2px;\n  --container-padding-bottom: 2px;\n  --container-padding-inline-start: 2px;\n  --container-padding-inline-end: 2px;\n  --container-transform-focus: scale(1.2);\n  --background-color: transparent;\n  --background-color-selected: var(--base-30);\n  --border-radius: 32px;\n  --icon-width: 28px;\n  --icon-height: 28px;\n  --counter-font-color: transparent;\n  --counter-font-color-selected: transparent;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ReactionItem__container-f8a51b`,
	"icon": `ReactionItem__icon-b8b6bb`,
	"counter": `ReactionItem__counter-e65396`,
	"selected": `ReactionItem__selected-bc5ec9`,
	"theme-1": `ReactionItem__theme-1-a46685`,
	"theme1": `ReactionItem__theme-1-a46685`,
	"theme-2": `ReactionItem__theme-2-ba5e7a`,
	"theme2": `ReactionItem__theme-2-ba5e7a`,
	"theme-3": `ReactionItem__theme-3-a55fc3`,
	"theme3": `ReactionItem__theme-3-a55fc3`,
	"theme-4": `ReactionItem__theme-4-d8d183`,
	"theme4": `ReactionItem__theme-4-d8d183`,
	"theme-6": `ReactionItem__theme-6-af19a8`,
	"theme6": `ReactionItem__theme-6-af19a8`
};
module.exports = ___CSS_LOADER_EXPORT___;
